import cx from 'classnames';

import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';
import Typography from '~/components/Typography';

interface Props {
  fontFamily: string;
  text: string;
  highlightBgColor: string;
  highlightTextColor: string;
}

const Badge = ({ highlightBgColor, text, fontFamily, highlightTextColor }: Props) => {
  const { classes } = useWebThemeContext();

  return (
    <div
      style={{
        backgroundColor: highlightBgColor,
      }}
      className={cx(
        classes.radius,
        'absolute -top-8 left-1/2 w-fit -translate-x-1/2 transform px-3 pb-1 text-center text-white',
      )}
    >
      <Typography as="span" size="xs" fontFamily={fontFamily} color={highlightTextColor}>
        <span className="whitespace-nowrap uppercase">{text}</span>
      </Typography>
    </div>
  );
};

export default Badge;
